export default __webpack_public_path__ + "static/media/clock_icon.f76209ef.svg";